<div class="dialog-wrapper export">
  <div class="dialog-header">
    <header>{{ 'exportAndSettings.download' | xTranslate }}</header>
    <button mat-icon-button mat-dialog-close [matTooltip]="'commonLabels.close' | xTranslate">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="exportForm">
      <div class="form-section" *ngFor="let config of formConfig">
        <p>{{ config.label | xTranslate }}</p>
        <!-- CHECKBOX -->
        <ng-container *ngIf="config.formType === formType.GROUP; else renderRadio">
          <div class="form-options" [formGroupName]="config.key">
            <div
              *ngFor="let option of config.options"
              [matTooltip]="option.tooltip | xTranslate"
              matTooltipPosition="above"
              matTooltipShowDelay="500"
            >
              <mat-checkbox [formControlName]="option.key">{{ option.label | xTranslate }}</mat-checkbox>
              <mat-icon *ngIf="option.icon" [svgIcon]="option.icon"></mat-icon>
            </div>
          </div>
        </ng-container>
        <!-- RADIO BUTTON -->
        <ng-template #renderRadio>
          <mat-radio-group class="form-options" [formControlName]="config.key">
            <div
              *ngFor="let option of config.options"
              [matTooltip]="option.tooltip | xTranslate"
              matTooltipPosition="above"
              matTooltipShowDelay="500"
            >
              <mat-radio-button [value]="option.key">
                <span>
                  {{ option.label | xTranslate }}
                </span>
              </mat-radio-button>
              <mat-icon *ngIf="option.icon" [svgIcon]="option.icon"></mat-icon>
            </div>
          </mat-radio-group>
        </ng-template>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-flat-button color="primary" [disabled]="exportForm.invalid" (click)="exportReport()">
      {{ 'exportAndSettings.export' | xTranslate }}
    </button>
  </div>
</div>
